export enum Status {
  ActiveSubscription = "active-subscription",
  Stolen = "stolen",
  WheeTeam = "whee-team",
  Demo = "demo",
  Resignation = "resignation",
  Recovered = "recovered",
  ComingSoon = "coming-soon",
  AvailableForSale = "available-for-sale",
  HardFix = "hard-fix",
  Preassigned = "preassigned",
  Returned = "returned",
  ReceivedFromVendor = "received-from-vendor",
  Sold = "sold"
}

const allATBikeStatus = [
  "Active subscription",
  "Stolen",
  "Whee! team",
  "Demo/spare",
  "Resignation",
  "Recovered",
  "Coming soon",
  "Available for sale",
  "Hard fix",
  "Preassigned to customer",
  "Returned from customer",
  "Received from vendor",
  "Sold"
] as const;

export type ATBikeStatus = (typeof allATBikeStatus)[number];

export const getAllATStatuses = (): typeof allATBikeStatus => {
  return allATBikeStatus;
};

export const fromATData = (status: ATBikeStatus): Status => {
  switch (status) {
    case "Active subscription":
      return Status.ActiveSubscription;
    case "Stolen":
      return Status.Stolen;
    case "Whee! team":
      return Status.WheeTeam;
    case "Demo/spare":
      return Status.Demo;
    case "Resignation":
      return Status.Resignation;
    case "Recovered":
      return Status.Recovered;
    case "Coming soon":
      return Status.ComingSoon;
    case "Available for sale":
      return Status.AvailableForSale;
    case "Hard fix":
      return Status.HardFix;
    case "Preassigned to customer":
      return Status.Preassigned;
    case "Returned from customer":
      return Status.Returned;
    case "Received from vendor":
      return Status.ReceivedFromVendor;
    case "Sold":
      return Status.Sold;
  }
};

export const toATData = (status: Status): ATBikeStatus => {
  switch (status) {
    case Status.ActiveSubscription:
      return "Active subscription";
    case Status.Stolen:
      return "Stolen";
    case Status.WheeTeam:
      return "Whee! team";
    case Status.Demo:
      return "Demo/spare";
    case Status.Resignation:
      return "Resignation";
    case Status.Recovered:
      return "Recovered";
    case Status.ComingSoon:
      return "Coming soon";
    case Status.AvailableForSale:
      return "Available for sale";
    case Status.HardFix:
      return "Hard fix";
    case Status.Preassigned:
      return "Preassigned to customer";
    case Status.Returned:
      return "Returned from customer";
    case Status.ReceivedFromVendor:
      return "Received from vendor";
    case Status.Sold:
      return "Sold";
  }
};
